import {
  CURRENT_ASSETS_NAMES,
  INITIAL_ASSETS_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialAssetsForm/utils/form';
import {
  CURRENT_LIABILITIES_NAMES,
  INITIAL_LIABILITIES_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialLiabilitiesForm/utils/form';
import {
  IOpeningBalanceSheets,
  OPENING_BALANCE_SHEETS_TABS_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/utils/form';

export const shouldRenderFinancialData = (data: IOpeningBalanceSheets): boolean => {
  const assets = data[OPENING_BALANCE_SHEETS_TABS_NAMES.INITIAL_ASSETS];
  const liabilities = data[OPENING_BALANCE_SHEETS_TABS_NAMES.INITIAL_LIABILITIES];
  const equity = data[OPENING_BALANCE_SHEETS_TABS_NAMES.INITIAL_EQUITY];

  const currentAssets = assets[INITIAL_ASSETS_NAMES.CURRENT_ASSETS];
  const nonCurrentAssets = assets[INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS];

  const currentLiabilities = liabilities[INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES];
  const nonCurrentLiabilities = liabilities[INITIAL_LIABILITIES_NAMES.NON_CURRENT_LIABILITIES];

  const isEquityFilled = Object.values(equity).some((value) => value);

  const isCurrentAssetsFilled = Object.entries(currentAssets)
    .filter((item) => item[0] !== CURRENT_ASSETS_NAMES.CREDIT_SALES_PAYMENT_DURATION)
    .some((item) => item[1]);
  const isNonCurrentAssetsFilled = Object.values(nonCurrentAssets).some((value) => value);

  const isCurrentLiabilitiesFilled = Object.entries(currentLiabilities)
    .filter((item) => item[0] !== CURRENT_LIABILITIES_NAMES.PAYMENT_DURATION_CREDIT_PURCHASES)
    .some((item) => item[1]);
  const isNonCurrentLiabilitiesFilled = Object.values(nonCurrentLiabilities).some((value) => value);

  return (
    isCurrentAssetsFilled ||
    isNonCurrentAssetsFilled ||
    isCurrentLiabilitiesFilled ||
    isNonCurrentLiabilitiesFilled ||
    isEquityFilled
  );
};
